<mat-icon mat-dialog-close class="btn-close float-right">close</mat-icon>
<mat-dialog-content class="contentModal">
    <div class="container-fluid" loader [switch]="loader">
        <div class="aling">
            <div class="table-sio w-100 ">
                <div class="row-sio w-100">
                    <div class="cell-sio w-100">
                        <div class="padding-txt">
                            <label class="font-titleTxt">Recibe asesoría personalizada</label><br>
                        </div>
                        <div class="padding-txt">
                            <label class="font-marcameTxt">Puedes marcarnos al:</label><br>
                        </div>
                        <div class="padding-txt">
                            <label class="font-numero">55442 46837</label><br>
                        </div>
                        <div class="padding-txt">
                            <label class="font-marcameTxt">O escribenos al correo </label>
                        </div>
                        <div class="padding-txt">
                            <label class="font-marcameTxt" style="color:'#009DD0'" (click)="ayudaMail()">renovaciones@inter.mx</label><br>
                        </div>
                    </div>
                </div>
                <br>
                <div class="padding-txt">
                    <label class="font-horario">Horario de atención: </label><br>
                    <label class="font-horario">De lunes a domingo de 8:00 a 20:00 hrs </label>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
